/**
 * Balance and price formatting.
 *
 * The API's `credits` field is CENTS, and the UI shows cents — a balance of
 * 1999 renders as "1,999¢", not "$19.99". Cents are the unit the product
 * prices in (30¢ a minute, 50¢ an export, 1¢ per 2000 characters), so
 * converting to dollars for display would force the user to convert back every
 * time they compared a balance against a price. The one place dollars belong is
 * what Stripe actually charges for a package or plan, which the API sends as a
 * preformatted `price` string.
 *
 * Rates are NOT defined here. They come from the API (the estimate endpoint
 * returns cents_per_minute and cents_per_cloud_export), so changing a price on
 * the backend changes every quote in the UI without a frontend deploy.
 */

/** Format cents as cents: `30¢`, `1,999¢`. Thousands separated for readability. */
export const formatCents = (cents) => {
  const n = Math.round(Number(cents) || 0);
  return `${n.toLocaleString()}¢`;
};

/**
 * Bare cents count, no unit — for places that render the `¢` separately (a
 * balance badge with its own label, say).
 */
export const centsValue = (cents) => Math.round(Number(cents) || 0).toLocaleString();

/**
 * Minutes a balance buys at a given rate. `ratePerMinute` must come from the
 * API — never hardcode it.
 */
export const minutesFor = (cents, ratePerMinute) => {
  if (!ratePerMinute) return 0;
  return Math.floor((Number(cents) || 0) / ratePerMinute);
};
